import serviceHub from '@/services/hub';
import { AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';

const actions: ActionTree<Store.Events.State, RootState> = {
  async loadEvent({ commit, dispatch }, payload: Services.Events.GetEvent): Promise<any> {
    return serviceHub.events.getEvent(payload)
      .then((res) => {
        commit('setEvent', res.data);
      })
      .catch(() => {
        dispatch(
          'notification/create', {
            text: 'Erro ao buscar um evento',
            type: 'error',
          }, { root: true },
        );
        return 'error';
      });
  },
  async loadEvents({ commit, dispatch }, payload: Services.Events.GetEvents): Promise<void> {
    return serviceHub.events.getEvents(payload)
      .then((res) => {
        commit('setSecret', res.data.secret);
        commit('setEvents', res.data.events);
        commit('setTotal', res.data.total);
      })
      .catch(() => dispatch(
        'notification/create', {
          text: 'Erro ao buscar os eventos',
          type: 'error',
        }, { root: true },
      ));
  },
  async createEvent({ commit, dispatch }, payload: Services.Events.PostEvent): Promise<any> {
    return serviceHub.events.postEvent(payload)
      .then((res: AxiosResponse) => {
        commit('addEvent', res.data);
        return res.data;
      })
      .catch(() => dispatch(
        'notification/create', {
          text: 'Erro ao criar evento',
          type: 'error',
        }, { root: true },
      ));
  },
  async edit({ commit, dispatch }, payload: Services.Events.PutEvent): Promise<any> {
    return serviceHub.events.putEvent(payload)
      .then(() => {
        commit('editEvent', payload);
        dispatch('notification/create', {
          text: 'Editado com sucesso!',
          type: 'success',
        }, { root: true });
      })
      .catch(() => {
        dispatch('notification/create', {
          text: 'Erro ao editar o evento',
          type: 'error',
        }, { root: true });
      });
  },
  async remove({ dispatch }, eventIds: number[]): Promise<any> {
    return serviceHub.events.deleteEvent(eventIds)
      .then(() => {
        // commit('removeEvents', eventIds);
        dispatch('notification/create', {
          text: 'Deletado com sucesso!',
          type: 'success',
        }, { root: true });
        return { status: 'Event deleted!' };
      })
      .catch(() => {
        dispatch('notification/create', {
          text: 'Erro ao deletar evento',
          type: 'error',
        }, { root: true });
      });
  },
  async startOrEndLive(
    { commit, dispatch },
    payload: Services.Events.StartOrEndLive,
  ): Promise<void> {
    return serviceHub.events
      .startOrEndLive(payload)
      .then(() => {
        const text = payload.status === 'LIVE'
          ? 'Evento iniciado!'
          : 'Evento finalizado!';
        commit('changeEventStatus', payload);
        dispatch('notification/create', {
          text,
          type: 'success',
        }, { root: true });
      })
      .catch((error) => {
        const text = error.response.data.error === 'Already have an event Live'
          ? 'already_have_event_live'
          : 'Erro ao atualizar o status do evento.';

        dispatch('notification/create', {
          text,
          type: 'error',
        }, { root: true });

        throw new Error(error);
      });
  },
  async download(
    { dispatch },
    payload: Services.Events.DownloadEvent,
  ): Promise<any> {
    return serviceHub.events.downloadEvent(payload)
      .then((response) => response)
      .catch(() => {
        dispatch('notification/create', {
          text: 'Erro ao baixar o evento.',
          type: 'error',
        }, { root: true });
      });
  },
};

export default actions;
